import styled, { css } from "styled-components";

import DefaultRow from "components/Form/Row";

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
`;

export const NutrientsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;

  max-width: 100%;
`;

export const NutrientContainer = styled(DefaultRow)`
  align-items: center;

  min-width: 370px;
  height: 54px;

  margin-bottom: 0;
  margin-right: 32px;

  :not(:last-child) {
    margin-bottom: 40px;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;

  ${({ width }: { width?: string }) =>
    css`
      width: ${width ?? "100%"};
    `}

  &:not(:last-child) {
    margin-right: 32px;
  }
`;

export const TitleRow = styled(DefaultRow)`
  margin-bottom: 10px;
`;
